/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';

type Subject = Partial<{
    lookupSubject: string;
}>;

const TeachingAndEducation = ({
    keyPerformanceIndicatorsTeaching,
    subjects,
    shortCourses,
    microcredentials,
}: Partial<{
    keyPerformanceIndicatorsTeaching: string;
    subjects: Subject[];
    shortCourses: Subject[];
    microcredentials: Subject[];
}>) => (
    <>
        {keyPerformanceIndicatorsTeaching && (
            <Row>
                <ValueCell label="Key Performance Indicators (KPIs)" value={keyPerformanceIndicatorsTeaching} />
            </Row>
        )}
        {Array.isArray(subjects) && subjects.length > 0 && (
            <Row>
                <SubHeading level={2} text="Subjects" />
            </Row>
        )}
        {subjects?.map((subject, i: number) => (
            <Row key={i}>
                <ValueCell single label={`Subject - ${i + 1}`} value={subject.lookupSubject} />
            </Row>
        ))}
        {Array.isArray(shortCourses) && shortCourses.length > 0 && (
            <Row>
                <SubHeading level={2} text="Short Courses" />
            </Row>
        )}
        {shortCourses?.map((shortCourse, i: number) => (
            <Row key={i}>
                <ValueCell single label={`Short Course - ${i + 1}`} value={shortCourse.lookupSubject} />
            </Row>
        ))}
        {Array.isArray(microcredentials) && microcredentials.length > 0 && (
            <Row>
                <SubHeading level={2} text="Microcredentials" />
            </Row>
        )}
        {microcredentials?.map((microcredential, i: number) => (
            <Row key={i}>
                <ValueCell single label={`Microcredential - ${i + 1}`} value={microcredential.lookupSubject} />
            </Row>
        ))}
    </>
);

export default TeachingAndEducation;
